"use client";

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { useEffect, useState } from "react";
import { updateCondition } from "../../firebase/conditions";
import DialogSuccess from "./DialogSuccess";
import { useAtom } from "jotai";
import { showManageConditionModalAtom } from "../../store";

export default function DialogEditCondition({
    open,
    onClose,
    condition
}) {
    const [label, setLabel] = useState('')
    const [value, setValue] = useState('')
    const [activeSubmit, setActiveSubmit] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [showSuccessDialog, setShowSuccessDialog] = useState(false)
    const [showManageConditionModal, setShowManageConditionModal] = useAtom(showManageConditionModalAtom)

    useEffect(() => {
        if (condition) {
            setLabel(condition.label || '')
            setValue(condition.value || '')
        }
    }, [condition])

    useEffect(() => {
        setActiveSubmit(label !== '' && value !== '')
    }, [label, value])

    const handleSubmit = async () => {
        if (!condition) return

        setIsLoading(true)
        
        try {
            await updateCondition({
                id: condition.id,
                label: label,
                value: value,
                state: condition.state
            })
            setShowManageConditionModal(false)
            setShowSuccessDialog(true)
        } catch (error) {
            console.error('Error updating condition:', error)
        } finally {
            setIsLoading(false)
        }
    }

    if (!condition) return null

    return (
        <>
            <DialogSuccess
                message="Condition is successfully updated"
                open={showSuccessDialog}
                onClose={() => setShowSuccessDialog(false)}
                buttonText="Back to Dashboard"
                title="Success"
                iconSrc="/assets/icons/icon-check-white-circle.svg"
                type="confirm"
            />

            <Dialog open={open} onClose={onClose} className="relative z-[10000]">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-[#000] backdrop-blur-sm bg-opacity-75 transition-opacity"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden w-[550px] bg-[#141414] backdrop-blur-sm shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in  rounded-[15px]"
                        >
                            <div className="w-full flex flex-col relative p-6 min-h-[400px]">
                                <div className="flex justify-between">
                                    <div className="flex">
                                        <span className="text-primary text-[28px]">Edit Condition</span>
                                    </div>

                                    <button
                                        onClick={onClose}
                                        className="top-2 right-2 cursor-pointer z-[1]"
                                    >
                                        <img
                                            src="/assets/icons/icon-close.svg"
                                            alt="Close"
                                            className="invert cursor-pointer"
                                        />
                                    </button>
                                </div>

                                <div className="mt-8">
                                    <div className="text-sm text-primary mb-2">
                                        Label
                                    </div>
                                    <input
                                        className="w-full rounded-[10px] pl-3 py-3 bg-[#272727] text-white"
                                        placeholder="Enter condition label"
                                        value={label}
                                        onChange={(e) => setLabel(e.target.value)}
                                    />
                                </div>

                                <div className="mt-6">
                                    <div className="text-sm text-primary mb-2">
                                        Value
                                    </div>
                                    <input
                                        className="w-full rounded-[10px] pl-3 py-3 bg-[#272727] text-white"
                                        placeholder="Enter condition value"
                                        value={value}
                                        onChange={(e) => setValue(e.target.value)}
                                    />
                                </div>

                                <div className="mt-6">
                                    <div className="text-sm text-primary mb-2">
                                        Current Status
                                    </div>
                                    <div className={`px-4 py-2 rounded-[10px] inline-block ${
                                        condition.state === 'active' 
                                            ? 'bg-green-500 text-white' 
                                            : 'bg-yellow-500 text-white'
                                    }`}>
                                        {condition.state === 'active' ? 'Active' : 'Pending'}
                                    </div>
                                </div>

                                <div className="flex mt-auto text-[#959595] text-sm justify-end">
                                    <button className="w-[143px] h-[42px]" onClick={onClose}>
                                        Cancel
                                    </button>

                                    <button
                                        className={`w-[143px] h-[42px] rounded-[10px] flex items-center justify-center ${
                                            activeSubmit && !isLoading ? 'bg-primary text-white' : 'bg-[#E5E5E5]'
                                        } ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                                        onClick={handleSubmit}
                                        disabled={!activeSubmit || isLoading}
                                    >
                                        {isLoading ? (
                                            <>
                                                <img src="/assets/icons/icon-loading.svg" alt="loading" className="w-4 h-4 animate-spin mr-2" />
                                                Updating...
                                            </>
                                        ) : (
                                            'Update'
                                        )}
                                    </button>
                                </div>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    );
} 